import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { UTILS__image } from '@/utils/UTILS__image';
import { path_relative_to_absolute } from '@/utils/utils_files_client';
import { assert_not_null } from '@shared/asserts/utils_asserts';
import { DTO__image_asset } from '@shared/dto/+image/image_asset_base/DTO__image_asset';

export function HOOK_CANVAS__draw_image_into_canvas() {
  /*
   * STORE
   */

  /*
   * METHODS
   */
  async function draw_image_into_canvas(canvas: HTMLCanvasElement, image: DTO__image_asset) {
    if (canvas == ENUM__html_ref_stub.CANVAS) return;
    if (canvas.width == 0 || canvas.height == 0) return;
    if (image.is_stub()) return;

    const context_destination = canvas.getContext('2d');
    assert_not_null(context_destination);

    let url_absolute = path_relative_to_absolute(image.url_relative_latest);

    const tag_image = await UTILS__image.load_from_url(url_absolute);

    context_destination.imageSmoothingEnabled = false;
    context_destination.imageSmoothingQuality = 'high';

    context_destination.clearRect(0, 0, canvas.width, canvas.height);
    context_destination.drawImage(tag_image, 0, 0, canvas.width, canvas.height);
  }

  /*
   * RESULT
   */

  return { draw_image_into_canvas };
}
